import { Link } from 'react-router-dom';
import { ArrowLeft, Calendar, Gift, Leaf } from 'lucide-react';

export default function ArtikelDattelsortenRamadan() {
  return (
    <main className="pt-20 md:pt-24 bg-[#FDFCF8]">
      <section className="py-16 md:py-24 bg-[#4A5D4F]">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <Link to="/ratgeber" className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-8 transition-colors"><ArrowLeft className="w-4 h-4" />Alle Ratgeber</Link>
          <div className="flex items-center gap-2 text-[#D4C5A9] text-sm mb-4"><Calendar className="w-4 h-4" /><span>Februar 2026</span></div>
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-medium text-white mb-6 leading-tight">Die besten Dattelsorten für Ramadan: Ein Kaufguide</h1>
          <p className="text-lg text-white/80 leading-relaxed">Medjool, Ajwa, Sukkari oder Deglet Nour? Wir vergleichen die beliebtesten Dattelsorten und verraten, wo du sie in Deutschland findest.</p>
        </div>
      </section>
      <article className="py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-6 md:px-12 prose prose-lg max-w-none">
          <p className="text-xl text-[#2C332E] leading-relaxed mb-8">Datteln sind DAS Symbol des Ramadan. Der Prophet Muhammad (s.a.s.) brach sein Fasten mit Datteln und Wasser – diese Sunnah wird bis heute weltweit von Muslimen praktiziert. Doch Dattel ist nicht gleich Dattel: Es gibt über 200 Sorten mit unterschiedlichen Geschmäckern und Texturen. Wir stellen die besten vor.</p>

          <section className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full bg-[#D4C5A9]/30 flex items-center justify-center"><Leaf className="w-6 h-6 text-[#4A5D4F]" /></div>
              <h2 className="font-serif text-2xl font-medium text-[#2C332E]">Premium-Sorten</h2>
            </div>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Medjool – Die Königin der Datteln</h4>
                <p className="text-sm text-[#4B5563]">Groß, weich und karamellig süß. Die Medjool-Dattel ist die bekannteste Premium-Sorte und in jedem Supermarkt erhältlich. Perfekt zum Fastenbrechen, zum Backen und als Snack.</p>
                <div className="mt-2 flex gap-4 text-xs text-[#4A5D4F]"><span>Herkunft: Jordanien, Israel, Marokko</span><span>Preis: ca. 15-25€/kg</span></div>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Ajwa – Die Dattel des Propheten</h4>
                <p className="text-sm text-[#4B5563]">Klein, dunkel und mit einem einzigartigen, leicht herben Geschmack. Ajwa-Datteln stammen aus Medina und haben eine besondere Bedeutung im Islam. In Hadithen wird ihnen heilende Wirkung zugeschrieben.</p>
                <div className="mt-2 flex gap-4 text-xs text-[#4A5D4F]"><span>Herkunft: Medina, Saudi-Arabien</span><span>Preis: ca. 30-60€/kg</span></div>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Sukkari – Die Süßeste</h4>
                <p className="text-sm text-[#4B5563]">Goldgelb und extrem süß – der Name bedeutet wörtlich "zuckrig". Weiche Textur mit einem buttrigen, karamellartigen Geschmack. In Saudi-Arabien die beliebteste Sorte.</p>
                <div className="mt-2 flex gap-4 text-xs text-[#4A5D4F]"><span>Herkunft: Al-Qassim, Saudi-Arabien</span><span>Preis: ca. 20-40€/kg</span></div>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Weitere beliebte Sorten</h2>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Deglet Nour – Die Dattel des Lichts</h4>
                <p className="text-sm text-[#4B5563]">Halbtrocken, bernsteinfarben und leicht nussig. Die am meisten exportierte Sorte weltweit. Hervorragend zum Kochen und Backen, da sie nicht zu weich ist.</p>
                <div className="mt-2 flex gap-4 text-xs text-[#4A5D4F]"><span>Herkunft: Tunesien, Algerien</span><span>Preis: ca. 8-15€/kg</span></div>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Khudri</h4>
                <p className="text-sm text-[#4B5563]">Mittelgroß, dunkelbraun und nicht zu süß. Trockener als Medjool, aber mit einem angenehmen, milden Geschmack. Gutes Preis-Leistungs-Verhältnis.</p>
                <div className="mt-2 flex gap-4 text-xs text-[#4A5D4F]"><span>Herkunft: Saudi-Arabien</span><span>Preis: ca. 10-18€/kg</span></div>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Mabroom</h4>
                <p className="text-sm text-[#4B5563]">Länglich, dünn und mit einer festen, leicht klebrigen Textur. Ähnlich wie Ajwa, aber milder im Geschmack und erschwinglicher. Ideal als täglicher Snack.</p>
                <div className="mt-2 flex gap-4 text-xs text-[#4A5D4F]"><span>Herkunft: Medina, Saudi-Arabien</span><span>Preis: ca. 15-25€/kg</span></div>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Safawi</h4>
                <p className="text-sm text-[#4B5563]">Dunkelbraun bis schwarz, weich und süß. Wird auch "die kleine Schwester der Ajwa" genannt, da sie ebenfalls aus Medina stammt, aber deutlich günstiger ist.</p>
                <div className="mt-2 flex gap-4 text-xs text-[#4A5D4F]"><span>Herkunft: Medina, Saudi-Arabien</span><span>Preis: ca. 12-20€/kg</span></div>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Wo kaufe ich Datteln in Deutschland?</h2>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Arabische & türkische Supermärkte</h4>
                <p className="text-sm text-[#4B5563]">Die beste Auswahl an Sorten und Qualitäten. Besonders vor Ramadan gibt es große Sonderangebote. Hier findest du auch Ajwa und Sukkari.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Online-Shops</h4>
                <p className="text-sm text-[#4B5563]">Amazon, spezielle Dattel-Shops und islamische Online-Händler bieten ein breites Sortiment mit Lieferung nach Hause. Ideal für seltene Sorten.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Bio-Läden & Supermärkte</h4>
                <p className="text-sm text-[#4B5563]">Medjool und Deglet Nour gibt es bei Rewe, Edeka, dm und in Bio-Läden. Für Ramadan gibt es manchmal Sonderaktionen.</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Datteln als Geschenk</h2>
            <div className="bg-[#4A5D4F]/10 rounded-xl p-6">
              <p className="text-[#4B5563] mb-4">Ein edles Dattel-Set ist ein wunderbares Eid-Geschenk:</p>
              <ul className="text-[#4B5563] space-y-3">
                <li><strong>Premium-Box:</strong> Verschiedene Sorten in einer Holzbox – von Ajwa bis Sukkari</li>
                <li><strong>Gefüllte Datteln:</strong> Mit Mandeln, Walnüssen oder Orangenschale gefüllt und in Schokolade getaucht</li>
                <li><strong>Dattel-Geschenkkorb:</strong> Kombiniert mit arabischem Kaffee, Honig und Nüssen</li>
                <li><strong>Personalisiert:</strong> Dattel-Box mit "Eid Mubarak"-Gravur oder Aufkleber</li>
              </ul>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Fazit</h2>
            <p className="text-[#4B5563] leading-relaxed mb-4">Ob Medjool für den Alltag, Ajwa für die Sunnah oder Sukkari für Naschkatzen – die richtige Dattel macht den Ramadan noch schöner. Probiere verschiedene Sorten aus und finde deinen Favoriten!</p>
            <p className="text-xl text-[#4A5D4F] font-medium">Ramadan Kareem!</p>
          </section>

          <div className="bg-[#F5F5F0] rounded-2xl p-6 mb-8">
            <h3 className="font-serif text-lg font-medium text-[#2C332E] mb-4">Weitere Artikel</h3>
            <ul className="space-y-2">
              <li><Link to="/ratgeber/ramadan-iftar-rezepte" className="text-[#4A5D4F] hover:underline">→ Ramadan Iftar Rezepte</Link></li>
              <li><Link to="/ratgeber/halal-suessigkeiten-deutschland" className="text-[#4A5D4F] hover:underline">→ Halal Süßigkeiten in Deutschland</Link></li>
            </ul>
          </div>

          <div className="bg-[#4A5D4F] rounded-2xl p-8 text-center">
            <h3 className="font-serif text-2xl font-medium text-white mb-4">Geschenke entdecken</h3>
            <Link to="/geschenke" className="inline-flex items-center gap-2 bg-white text-[#4A5D4F] px-8 py-3 rounded-full font-medium hover:bg-[#D4C5A9] transition-colors">Jetzt stöbern<Gift className="w-5 h-5" /></Link>
          </div>
        </div>
      </article>
    </main>
  );
}
